import { BASE_URL_LEGACY } from "./";

export const dashboardService = {
  getDetail,
};

function getDetail() {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  };

  return fetch(`${BASE_URL_LEGACY}/dashboard/`, requestOptions)
    .then((response) => {
      if (!response.ok) {
        return Promise.reject(response);
      }
      return response.json();
    })
    .then((detail) => {
      let user = JSON.parse(localStorage.getItem("user"));
      detail.map((item) => {
        // if (item.user_id) {
        //   user.user_id = item.user_id;
        //   user.user_title = item.title;
        // }
        // if (item.dependant_user_id) {
        //   user.dependant_user_id = item.dependant_user_id;
        //   user.dependant_title = item.title;
        // }

        return true;
      });

      const isDemoUser = detail.filter(x => 'demo_user' in x && x.demo_user).length > 0;

      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("is_demo_user", JSON.stringify(isDemoUser));

      return detail;
    });
}
